'use strict';

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');

module.exports = /*@ngInject*/ ["$uibModal", "ProjectService", "AdvancedQueryResourceService", "AuthenticationFactory", "$q", "$timeout", "$uibModalStack", function ($uibModal, ProjectService, AdvancedQueryResourceService, AuthenticationFactory, $q, $timeout, $uibModalStack) {
    return {
        restrict: 'EA',
        require: '^ngModel',
        scope: {
            ngModel: '=',
            queryError: '=',
            executeQuery: '&',
            startCollapsed: '='
        },
        template: [
            '<div class="pull-left fullheight">',
            '   <div uib-collapse="isCollapsed">',
            '       <div class="padding-left-5px font-13px width-200px">',
            '           <span class="nav-header">FILTERS</span>',
            '           <div class="padding-top-5px">',
            '               <div class="margin-left-20px">',
            '                   <div class="btn btn-sm btn-default fullwidth margin-top-10px" ng-click="newFilter()">New filter</div>',
            '                   <div class="btn btn-sm btn-default fullwidth margin-top-10px" ng-disabled="queryError || ngModel == \'\'" ',
            '                   ng-click="saveFilter()">Save filter</div>',
            '               </div>',
            '               <div class="margin-left-20px margin-top-10px">',
            '                   <a class="hover" ng-click="browseFilters()">Browse existing filters</a>',
            '               </div>',
            '           </div>',
            '           <span class="block separator margin-right--30px"></span>',
            '           <div>',
            '               <span class="nav-header">FAVORITES <i class="fa fa-refresh fa-spin pull-right" ng-show="loading"></i></span>',
            '               <div class="padding-left-20px padding-top-10px">',
            '                   <div ng-show="!favorites">No favorite filters found!</div>',
            '                   <ul class="list-unstyled fullwidth" ng-show="favorites.length > 0">',
            '                       <li class="padding-bottom-8px" ng-repeat="fav in favorites | pagination: curPage * pageSize | limitTo: pageSize">',
            '                       <a class="hover" ng-click="loadFilter(fav)">{{fav.filter.name | strLimit : 16}}</a></li>',
            '                   </ul>',
            '                   <div ng-show="favorites.length > pageSize">',
            '                       <button class="btn btn-default btn-xs" type="button" ng-disabled="curPage == 0" ng-click="curPage=curPage-1">PREV</button>',
            '                       <button class="btn btn-default btn-xs" type="button" ng-disabled="curPage >= favorites.length/pageSize - 1" ',
            '                       ng-click="curPage = curPage+1">NEXT </button>',
            '                   </div>',
            '               </div>',
            '           </div>',
            '       </div>',
            '   </div>',
            '</div>',
            '<div class="pull-left fullheight">',
            '   <div class="text-center width-30px">',
            '       <i class="fa fa-bars fa-lg hover" ng-click="isCollapsed = !isCollapsed"></i>',
            '   </div>',
            '</div>'
        ].join(''),

        link: function (scope) {
            scope.favorites = [];
            scope.loading = false;
            scope.curPage = 0;
            scope.pageSize = 15;

            scope.isCollapsed = scope.startCollapsed;

            var favDeferred;
            var browseModal;
            var saveModal;

            init();

            function init() {
                fetchFavoriteFilters();
            }

            scope.newFilter = function () {
                scope.ngModel = "";
            };

            scope.saveFilter = function () {
                var query = scope.ngModel;
                if (util.isDefined(saveModal)) {
                    saveModal.dismiss();
                }
                saveModal = $uibModal.open({
                    template: [
                        '<div class="modal-header">',
                        '<h3>Save filter</h3>',
                        '</div>',
                        '<form name="filterSaveForm" role="form" class="" novalidate>',
                        '<div class="modal-body">',
                        '<label>Filter: </label> </br><code class="black">{{query}}</code> </br> </br>',
                        '<div class="form-group"',
                        'ng-class="{ \'has - error\' : filterSaveForm.queryName.$invalid && !filterSaveForm.queryName.$pristine }">',
                        '<label>Filter name:</label><input type="text" name="queryName" id="queryName" class="form-control" maxlength="80"',
                        'ng-model="queryName" ng-enter="!filterSaveForm.$invalid ? save() : null"',
                        'required/>',
                        ' </div>',
                        '<div class="modal-footer">',
                        '<button type="button" class="btn btn-default" ng-click="close()" data-dismiss="modal">{{\'CLOSE\' | translate }}',
                        '</button>',
                        '<button type="button" class="btn btn-primary" ng-disabled="filterSaveForm.$invalid" ng-click="save()">{{\'SAVE\' | translate }}',
                        ' </button>',
                        '</div>',
                        '</form>'
                    ].join(''),
                    controller: ["$scope", "$uibModalInstance", "$uibModal", "query", function SaveFilterModalController($scope, $uibModalInstance, $uibModal, query) {
                        $scope.queryName = "";
                        $scope.query = query;
                        $scope.close = function () {
                            $uibModalInstance.dismiss();
                        };

                        $scope.save = function () {
                            $uibModalInstance.close($scope.queryName);
                        }
                    }],
                    resolve: {
                        query: function () {
                            return query;
                        }
                    }
                });

                saveModal.result.then(function (data) {
                    var filter = {
                        query: query,
                        name: data,
                        projectId: ProjectService.getSelectedProjectId(),
                        creator: {
                            id: AuthenticationFactory.getUser().id
                        }
                    };
                    AdvancedQueryResourceService.filter().save({projectId: ProjectService.getSelectedProjectId()}, filter).$promise.then(function (data) {
                        var favoriteObject = {
                            user: {
                                id: AuthenticationFactory.getUser().id
                            },
                            filter: data
                        };
                        AdvancedQueryResourceService.favorite().save({projectId: ProjectService.getSelectedProjectId()}, favoriteObject).$promise.then(function () {
                            fetchFavoriteFilters();
                        });
                    })
                });
            };

            function fetchFavoriteFilters() {
                scope.loading = true;
                favDeferred = $q.defer();
                AdvancedQueryResourceService.favoriteForUser().query({
                    userId: AuthenticationFactory.getUser().id,
                    projectId: ProjectService.getSelectedProjectId()
                }).$promise.then(function (data) {

                    scope.favorites = [];
                    if (data.length > 0) {
                        data.forEach(function (entry) {
                            scope.favorites.push(entry);
                        })
                    }
                    favDeferred.resolve();
                    scope.loading = false;
                });
            }

            scope.browseFilters = function () {
                if (util.isDefined(browseModal)) {
                    // browseModal.close();
                    browseModal.opened.finally(function () {
                        $uibModalStack.dismissAll();
                    });
                }

                browseModal = $uibModal.open({
                    template: [
                        '<div class="modal-header">',
                        '<h3>Browse filters</h3>',
                        '</div>',
                        '<div class="modal-body">',
                        '<label>Filters: </label>',
                        '<div ng-show="filters.length == 0">No filters found for this project!</div>',
                        '<div class="height-450px">',
                        '<ul class="list-group fullwidth" ng-show="filters.length > 0">',
                        '<li class="list-group-item hoverbg" ng-mouseover="showQuery(filter.query)" ng-mouseleave="showQuery(null)" style="cursor:default;"',
                        ' ng-repeat="filter in filters | pagination: curPage * pageSize | limitTo: pageSize"><i>{{filter.name | strLimit : 50}}</i> ',
                        '<i class="fa fa-times fa-lg hover pull-right padding-left-10px d9534f"  ng-show="filter.creator.id == userId" ',
                        'ng-click="deleteFilter(filter)"></i>',
                        '<i class="fa fa-star-o fa-lg hover pull-right padding-left-10px" ',
                        'ng-show="!filter.$add" ng-click="filter.$add = true"></i>',
                        '<i class="fa fa-star fa-lg hover pull-right padding-left-10px" ',
                        'ng-show="filter.$add" ng-click="filter.$add = false"  style="color:#e3cf7a;"></i>',
                        '</li>',
                        '</ul>',
                        '<div ng-show="filters.length > pageSize">',
                        '<button class="btn btn-default btn-xs" type="button" ng-disabled="curPage == 0" ng-click="curPage=curPage-1">PREV</button>',
                        '<button class="btn btn-default btn-xs" type="button" ng-disabled="curPage >= filters.length/pageSize - 1" ng-click="curPage = curPage+1">NEXT </button>',
                        '</div>',
                        '</div>',
                        '<div class="padding-top-10px"><label>Current filter: </label> </br><code class="black">{{query}}</code></div>',
                        '</div>',
                        '<div class="modal-footer">',
                        '<button type="button" class="btn btn-default" ng-click="close()" data-dismiss="modal">{{\'CLOSE\' | translate }}',
                        '</button>',
                        '<button type="button" class="btn btn-primary" ng-disabled="filterSaveForm.$invalid" ng-click="save()">{{\'SAVE\' | translate }}',
                        ' </button>',
                        '</div>'
                    ].join(''),

                    controller: ["$scope", "$uibModalInstance", "$uibModal", "AuthenticationFactory", "filters", "favorites", function SaveFilterModalController($scope, $uibModalInstance, $uibModal, AuthenticationFactory, filters, favorites) {
                        $scope.userId = AuthenticationFactory.getUser().id;
                        $scope.filters = filters.splice(0);
                        $scope.curPage = 0;
                        $scope.pageSize = 10;

                        var adjustedFilters = [];
                        favorites.forEach(function (fav) {
                            var filter = arrayUtil.getFirstInList($scope.filters, 'id', fav.filter.id);
                            if (util.isDefined(filter)) {
                                filter.fav = true;
                                filter.$add = true;
                            }
                        });

                        $scope.deleteFilter = function (filter) {
                            filter.$del = true;
                            var index = $scope.filters.indexOf(filter);
                            $scope.filters.splice(index, 1);
                            adjustedFilters.push(filter);
                        };

                        $scope.showQuery = function (query) {
                            $scope.query = query;
                        };


                        $scope.close = function () {
                            $uibModalInstance.dismiss();
                        };

                        $scope.save = function () {

                            $scope.filters.forEach(function (f) {
                                if (f.$add || f.$del) {
                                    adjustedFilters.push(f);
                                }

                                if (f.fav && !f.$add) {
                                    f.$unfav = true;
                                    adjustedFilters.push(f);
                                }

                            });
                            $uibModalInstance.close(adjustedFilters);
                        }
                    }],
                    resolve: {
                        filters: ["ProjectService", "AdvancedQueryResourceService", function (ProjectService, AdvancedQueryResourceService) {
                            return AdvancedQueryResourceService.filters().query({projectId: ProjectService.getSelectedProjectId()}).$promise;
                        }],
                        favorites: function () {
                            var deferred = $q.defer();
                            favDeferred.promise.then(function () {
                                deferred.resolve(scope.favorites);
                            });
                            return deferred.promise;
                        }

                    }
                });

                browseModal.result.then(function (data) {
                    var promiseArray = [];
                    data.forEach(function (f) {
                        if (util.isDefined(f.$unfav) && f.$unfav) {
                            scope.favorites.some(function (fav) {
                                if (fav.filter.id == f.id) {
                                    promiseArray.push(deleteFavorite(fav));
                                }
                            })
                        }
                        else if (util.isDefined(f.$add) && f.$add && !f.fav) {
                            var favoriteObject = {
                                user: {
                                    id: AuthenticationFactory.getUser().id
                                },
                                filter: f
                            };
                            promiseArray.push(AdvancedQueryResourceService.favorite().save({
                                projectId: ProjectService.getSelectedProjectId()
                            }, favoriteObject).$promise);
                        } else if (util.isDefined(f.$del) && f.$del) {
                            promiseArray.push(AdvancedQueryResourceService.filter().remove({
                                id: f.id,
                                projectId: ProjectService.getSelectedProjectId()
                            }).$promise);
                        }
                    });

                    $q.all(promiseArray).then(function () {
                        fetchFavoriteFilters();
                    });
                });
            };


            scope.loadFilter = function (fav) {
                scope.ngModel = fav.filter.query;
                if (util.isDefined(scope.executeQuery)) {
                    $timeout(function () {
                        scope.executeQuery();
                    });

                }
            };

            var deleteFavorite = function (fav) {
                return AdvancedQueryResourceService.favorite().remove({
                    id: fav.id,
                    projectId: ProjectService.getSelectedProjectId()
                }).$promise
            };

        }
    }
}];